const cima = require('@/regulator/cima.js')
const svg = require('@/regulator/svg.js')
const { menuId } = require('./constants/menu')
const { BankInfoDetail } = require('./constants/bankInfoDetail')
const regulator = {
  cima,
  svg,
}

module.exports = {
  platformLang: 'en_US',
  info: {
    fullName: 'VT Markets',
    entityName: 'VT Markets Limited',
    getUrl(reg) {
      return reg ? regulator[reg].info.url : ''
    },
    getUrlCn(reg) {
      return reg ? regulator[reg].info.urlCn : ''
    },
    getUrlTw(reg) {
      return reg ? regulator[reg].info.urlTw : ''
    },
    getUrlIr(reg) {
      return reg ? regulator[reg].info.urlIr : ''
    },
    getMap(reg) {
      return regulator[reg].info.map
    },
    getMapIran(reg) {
      return regulator[reg].info.mapIran
    },
    getAddress(reg) {
      return regulator[reg].info.address
    },
    getAddressIran(reg) {
      return regulator[reg].info.addressIran
    },
    getLoginAddress(reg) {
      return regulator[reg].info.loginAddress
    },
    getEmail(reg) {
      return reg ? regulator[reg].info.email : ''
    },
    getDepositEmail(reg) {
      return reg ? regulator[reg].info.depositEmail : ''
    },
    getName(reg) {
      return reg ? regulator[reg].info.name : ''
    },
    getNameIran(reg) {
      return reg ? regulator[reg].info.nameIran : ''
    },
    getWithdrawalEmail(reg) {
      return reg ? regulator[reg].info.withdrawalEmail : ''
    },
  },
  restrictOpenAdditionAccountCountries(reg) {
    return reg ? regulator[reg].restrictOpenAdditionAccountCountries : {}
  },
  restrictDepositFundsByCountries(reg) {
    return reg ? regulator[reg].restrictDepositFundsByCountries : {}
  },
  menu: [
    {
      id: menuId.clientPortal,
      name: 'menu.CLIENT_PORTAL',
      children: [
        {
          id: menuId.home,
          name: 'menu.home',
          path: '/home',
          icon: require('@/assets/images/menu/menu_icon_home.png'),
          iconHover: require('@/assets/images/menu/menu_icon_home_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_home_active.png'),
        },
      ],
    },
    {
      id: menuId.features,
      name: 'menu.FEATURES',
      children: [
        {
          id: menuId.accManagement,
          name: 'menu.accManagement',
          path: '/liveAccount',
          icon: require('@/assets/images/menu/menu_icon_account.png'),
          iconHover: require('@/assets/images/menu/menu_icon_account_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_account_active.png'),
        },
        {
          id: menuId.funds,
          name: 'menu.funds',
          path: '/funds',
          icon: require('@/assets/images/menu/menu_icon_funds.png'),
          iconHover: require('@/assets/images/menu/menu_icon_funds_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_funds_active.png'),
          children: [
            {
              id: menuId.depositFund,
              checkBlacklist: true,
              name: 'menu.depositFund',
              path: '/depositFunds',
            },
            {
              id: menuId.withdrawFunds,
              checkBlacklist: true,
              name: 'menu.withdrawFunds',
              path: '/withdrawFunds',
            },
            {
              id: menuId.transferBetweenAccs,
              checkBlacklist: true,
              name: 'menu.transferBetweenAccs',
              path: '/transferFunds',
            },
            {
              id: menuId.payDetails,
              name: 'menu.payDetails',
              path: '/paymentDetails',
            },
            {
              id: menuId.transactionHis,
              name: 'menu.transactionHis',
              path: '/transactionHistory',
            },
          ],
        },
        {
          id: menuId.propTrade,
          name: 'menu.propTrade',
          path: '/propTrading',
          icon: require('@/assets/images/menu/menu_icon_prop_trading.png'),
          iconHover: require('@/assets/images/menu/menu_icon_prop_trading.png'),
          iconActive: require('@/assets/images/menu/menu_icon_prop_trading.png'),
          children: [
            {
              id: menuId.propTradeDashboard,
              name: 'menu.propTradeDashboard',
              path: '/propTrading/dashboard',
            },
            {
              id: menuId.propTradeCreateAccount,
              name: 'menu.propTradeCreateAccount',
              path: '/propTrading/createAccount',
            },
            {
              id: menuId.propTradeAchievement,
              name: 'menu.propTradeAchievement',
              path: '/propTrading/achievement',
            },
          ],
        },
        {
          id: menuId.download,
          name: 'menu.download',
          path: '/downloads',
          icon: require('@/assets/images/menu/menu_icon_downloads.png'),
          iconHover: require('@/assets/images/menu/menu_icon_downloads_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_downloads_active.png'),
        },
        {
          id: menuId.profile,
          name: 'menu.profile',
          path: '/profile',
          icon: require('@/assets/images/menu/menu_icon_profile.png'),
          iconHover: require('@/assets/images/menu/menu_icon_profile_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_profile_active.png'),
          children: [
            {
              id: menuId.myProfile,
              name: 'menu.myProfile',
              path: '/myProfile',
            },
            // {
            //   id: menuId.cpPassword,
            //   name: 'menu.cpPassword',
            //   path: '/changePassword',
            // },
            {
              id: menuId.securityManagement,
              name: 'menu.securityManagement',
              path: '/securityManagement',
            },
          ],
        },
        {
          id: menuId.tradingTools,
          name: 'menu.tradingTools',
          path: '/tradingTool/MARKET_BUZZ',
          icon: require('@/assets/images/menu/menu_icon_tools.png'),
          iconHover: require('@/assets/images/menu/menu_icon_tools_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_tools_active.png'),
          children: [
            {
              id: menuId.fxIdeas,
              name: 'menu.FX_IDEAS',
              path: '/tradingTool/FX_IDEAS',
            },
            {
              id: menuId.marketBuzz,
              name: 'menu.MARKET_BUZZ',
              path: '/tradingTool/MARKET_BUZZ',
            },
            {
              id: menuId.econCalendar,
              name: 'menu.ECON_CALENDAR',
              path: '/tradingTool/ECON_CALENDAR',
            },
            {
              id: menuId.featFx,
              name: 'menu.FEAT_FX',
              path: '/tradingTool/FEAT_FX',
            },
            // {
            //   id: menuId.howTrade,
            //   name: 'menu.HOW_TRADE',
            //   path: '/tradingTool/HOW_TRADE',
            // },
            {
              id: menuId.asCentre,
              name: 'menu.AS_CENTRE',
              path: '/tradingTool/AS_CENTRE',
            },
          ],
        },
        {
          id: menuId.vtrade,
          name: 'menu.vtrade',
          path: '/vtrade',
          icon: require('@/assets/images/menu/menu_icon_vtrade.png'),
          iconHover: require('@/assets/images/menu/menu_icon_vtrade_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_vtrade_active.png'),
          children: [
            {
              id: menuId.vtradeProvider,
              name: 'menu.vtradeProvider',
              path: '/vtrade/Provider',
              externalLink: countryCode => {
                switch (countryCode) {
                  case 1:
                  case 7033:
                  case 7069:
                    return 'https://www.vtacademy.net/become-a-provider-cn/'

                  default:
                    return 'https://www.vtacademy.net/become-a-provider/'
                }
              },
            },
            {
              id: menuId.vtradeFollower,
              name: 'menu.vtradeFollower',
              path: '/vtrade/becomes-a-follower',
            },
            {
              id: menuId.vtradeLogin,
              name: 'menu.vtradeLogin',
              path: '/vtrade/Login',
              externalLink: () => {
                return 'https://social.vtacademy.net/portal/login'
              },
            },
          ],
        },
        {
          id: menuId.promotion,
          name: 'menu.promotion',
          path: '/referFriends',
          icon: require('@/assets/images/menu/menu_icon_promotion.png'),
          iconHover: require('@/assets/images/menu/menu_icon_promotion_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_promotion_active.png'),
          children: [
            {
              id: menuId.redepositBonus,
              name: 'menu.redepositBonus',
              path: '/redepositBonus',
            },
            {
              id: menuId.welcomeBonus,
              name: 'menu.welcomeBonus',
              path: '/welcomeBonus',
            },
            {
              id: menuId.referAFriend,
              name: 'menu.referAFriend',
              path: '/referFriends',
            },
            {
              id: menuId.noDepositBonus,
              name: 'menu.noDepositBonus',
              path: '/noDepositBonus',
            },
            {
              id: menuId.dailyNewsletter,
              name: 'menu.dailyNewsletter',
              path: '/dailyNewsletter',
            },
            {
              id: menuId.lossRecover,
              name: 'menu.lossRecover',
              path: '/lossRecover',
            },
            {
              id: menuId.fundsGrowthPromotion,
              name: 'menu.fundsGrowthPromotion',
              path: '/fundsGrowthPromotion',
            },
            {
              id: menuId.vpsRefund,
              name: 'menu.vpsRefund',
              path: '/vpsRefund',
            },
            {
              id: menuId.luckyDraw,
              name: 'menu.luckyDraw',
              path: '/luckyDraw',
            },
          ],
        },
        {
          id: menuId.clubBleu,
          name: 'menu.clubBleu',
          path: '/clubBleu',
          icon: require('@/assets/images/menu/menu_icon_reward.png'),
          iconHover: require('@/assets/images/menu/menu_icon_reward_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_reward_active.png'),
        },
        {
          id: menuId.support,
          name: 'menu.support',
          path: '/support',
          icon: require('@/assets/images/menu/menu_icon_contact.png'),
          iconHover: require('@/assets/images/menu/menu_icon_contact_hover.png'),
          iconActive: require('@/assets/images/menu/menu_icon_contact_active.png'),
          children: [
            { name: 'menu.myTickets', path: '/myTickets' },
            { name: 'menu.contactUs', path: '/contactUs' },
          ],
        },
      ],
    },
  ],
  accountTypeMaps: {
    0: 'ALL', // "", mt4
    1: 'Standard STP', // standardSTP, mt4
    2: 'Raw ECN', // rawECN, mt4
    3: 'Standard STP & Binary Options', // "", mt4
    4: 'Raw ECN & Binary Options', // "", mt4
    5: 'Binary Options Only', // "", mt4
    6: 'Swap-free Standard STP', // swapFreeStandardSTP, mt4
    7: 'Swap-free Raw ECN', // swapFreeRawECN, mt4
    8: 'PRO ECN', // proECN, mt4
    9: 'VIP STP', // 9, mt4
    10: 'PAMM', // PAMM, mt4
    101: 'Standard STP', // "", mt5
    11: 'Net STP', // "", mt5
    12: 'Net ECN', // "", mt5
    13: 'Standard STP', // standardSTP, mt5
    14: 'Raw ECN', // rawECN, mt5
    15: 'Swap-free Standard STP', // swapFreeStandardSTP, mt5
    16: 'Swap-free Raw ECN', // swapFreeRawECN, mt5
    17: 'MT5 PRO', // proECN, mt5
    18: 'VIP STP', // 9, mt5
    19: 'Cent STP', // STANDARD_STP_CENT, mt4
    20: 'Cent Swap-free STP', // ISLAMIC_STP_CENT, mt4
    22: 'Cent ECN', // RAW_ECN_CENT, mt4
    23: 'Cent Swap-free ECN', // ISLAMIC_ECN_CENT, mt4
    24: 'Cent STP', // STANDARD_STP_CENT, mt5
    25: 'Cent Swap-free STP', // ISLAMIC_STP_CENT, mt5
    26: 'Cent ECN', // RAW_ECN_CENT, mt5
    27: 'Cent Swap-free ECN', // ISLAMIC_ECN_CENT, mt5
    28: 'PAMM', // PAMM, mt5
    39: 'Swap-free VIP STP', // swapFreeVipStp, mt4
    40: 'VIP STP Cent', // vipStpCent, mt4
    41: 'Swap-free VIP STP Cent', // swapFreeVipStpCent, mt4
    42: 'Swap-free VIP STP', // swapFreeVipStp, mt5
    43: 'VIP STP Cent', // vipStpCent, mt5
    44: 'Swap-free VIP STP Cent', // swapFreeVipStpCent, mt5
    99: 'MTS ST',
    100: 'MTS Hedge STP',
    102: 'MTS Swap free STP',
    103: 'MTS Swap free ECN',
    104: 'MTS Standard STP Cent',
    105: 'MTS Swap free STP Cent',
    106: 'MTS Pro Standard',
    107: 'MTS Raw ECN Cent',
    108: 'MTS Swap free ECN Cent',
    109: 'MTS ECN',
    110: 'MTS Hedge ECN',
    111: 'MTS PRO ECN',
    112: 'MTS Swap free VIP STP',
    113: 'MTS Swap free VIP STP Cent',
    114: 'MTS VIP STP Cent',
    115: 'MTS Hedge VIP STP',
  },
  openLiveAccount: {
    choosePlatform(reg) {
      return regulator[reg].openLiveAccount.choosePlatform
    },
    // open mt4, mt5 live account
    chooseLiveType(reg, countryCode = -1, showUsc = false) {
      const result = regulator[reg].openLiveAccount.chooseLiveType

      const countryArr = regulator[reg].openLiveAccount.uscIncludeCountry || []
      if (countryArr.includes(parseInt(countryCode))) {
        return result.filter(({ excludeCountry = {} }) => {
          if (showUsc) return true
          if (excludeCountry[countryCode]) return false
          return true
        })
      } else {
        return result.filter(({ hiddenState = false, excludeCountry = {} }) => {
          if (showUsc) return true
          if (hiddenState || excludeCountry[countryCode]) return false
          return true
        })
      }
    },
    ibChooseType(reg) {
      return regulator[reg].openLiveAccount.ibChooseType
    },
    // register mt4, mt5 account
    chooseRegisterType(reg, countryCode = -1, showUsc = false) {
      const result = regulator[reg].openLiveAccount.chooseRegisterType || []
      const countryArr = regulator[reg].openLiveAccount.uscIncludeCountry || []
      return result.filter(({ hiddenState = false }) => {
        if (showUsc) return true
        if (hiddenState && !countryArr.includes(parseInt(countryCode))) return false
        return true
      })
    },
    // open mt4 demo account
    mt4DemoChooseType(reg) {
      return regulator[reg].openLiveAccount.mt4DemoChooseType
    },
    // open mt5 demo account
    mt5DemoChooseType(reg) {
      return regulator[reg].openLiveAccount.mt5DemoChooseType
    },
    filterCurrency(reg, countryCode = -1) {
      const result = regulator[reg].openLiveAccount.chooseCurrency || []
      const countryArr = regulator[reg].openLiveAccount.uscIncludeCountry || []

      if (countryArr.includes(parseInt(countryCode))) {
        return result
      } else {
        return result.filter(f => f.currency != 'USC')
      }
    },
    chooseCurrency(reg, tradingPlatform = '', accountType = '', countryCode = -1, currency = 'All', showUsc = false) {
      const currencyList = regulator[reg].openLiveAccount.chooseCurrency || []
      const countryArr = regulator[reg].openLiveAccount.uscIncludeCountry || []
      const countryHkdArr = regulator[reg].openLiveAccount.hkdIncludeCountry || []
      const uscCurrency = regulator[reg].openLiveAccount.uscOnly || []
      const centAccountType = regulator[reg].openLiveAccount.chooseAccountType || []

      var result = currencyList.filter(({ excludeCountry = {} }) => {
        if (excludeCountry[countryCode]) return false
        return true
      })

      // filter out hkd from the currency list
      if (!countryHkdArr.includes(parseInt(countryCode))) {
        result = result.filter(r => r.currency !== 'HKD')
      }

      if (currency != 'All') {
        result = result.filter(item => currency.includes(item.currency))
      }

      if (!accountType) {
        return result.filter(({ hiddenState = false }) => {
          if (hiddenState) return false
          return true
        })
      } else if (centAccountType.includes(accountType) && showUsc) {
        return uscCurrency
      } else if (countryArr.includes(parseInt(countryCode))) {
        if (accountType === 'PAMM' && tradingPlatform === 'mt5') {
          result = result.filter(f => f.currency !== 'USC')
        }

        return result.filter(({ monetaryPolicy = {} }) => {
          if (monetaryPolicy[accountType] && monetaryPolicy[tradingPlatform]) return false

          return true
        })
      } else {
        return result.filter(({ hiddenState = false, monetaryPolicy = {} }) => {
          if (hiddenState || (monetaryPolicy[accountType] && monetaryPolicy[tradingPlatform])) return false
          return true
        })
      }
    },
    chooseLeverage(reg) {
      return regulator[reg].openLiveAccount.chooseLeverage
    },
    chooseBalance(reg) {
      return regulator[reg].openLiveAccount.chooseBalance
    },
    getAllCurrency(reg) {
      return regulator[reg].openLiveAccount.chooseCurrency
    },
    getAgreeCondition(reg) {
      return regulator[reg].openLiveAccount.getAgreeCondition
    },
  },
  getMetaTraderLinks(reg) {
    return regulator[reg].getMetaTraderLinks
  },
  bank_infos(currency, reg, bank, countryCode) {
    let bank_infos = []
    const bankInfoDetail = regulator[reg].bankInfoDetails[bank]
    const selectedCurrency = currency === 'USC' ? 'USD' : currency

    if (bank === 'BLACKTHORN' || bank === 'OPENPAYD' || bank === 'EQUALS' || bank === 'NAB') {
      if (bankInfoDetail instanceof BankInfoDetail) {
        bank_infos = bankInfoDetail.toBankInfos(selectedCurrency, countryCode)
      }
    }

    return bank_infos
  },
  country_transferOptions: [
    {
      code: 2,
      nameKey: 'common.country.international',
    },
  ],
  paymentMethods: [
    {
      label: 'common.withdrawChannel.unionpay',
      component: 'UnionPayRegister',
    },
  ],
  depositDefaultAmountMin: 100,
  depositDefaultAmountMax: 99999999.99,
  depositOneAmountMin: 1,
  deposit50AmountMin: 50,
  banner(reg) {
    return regulator[reg].banner
  },
  pageLoader(regulator = 'cima', componentName) {
    return import(`@/views/regulator/${regulator}/${componentName}`)
  },
  // componentLoader(regulator = 'cima', componentName, checkFileExist = false) {
  //   function fileInfo(exist = false, component) {
  //     this.exist = exist
  //     this.component = component
  //   }

  //   let file = new fileInfo()

  //   if (checkFileExist) {
  //     let components
  //     if (regulator == 'cima') {
  //       components = require.context(`@/components/regulator/cima`, true, /^\.\/.*\.vue$/)
  //     }

  //     if (components) {
  //       components.keys().map(requireContext => {
  //         const fileName = requireContext.replace('./', '').replace('.vue', '')
  //         if (fileName === componentName) {
  //           file.exist = true
  //           file.component = import(`@/components/regulator/${regulator}/${componentName}`)
  //         }
  //       })
  //     }
  //   } else {
  //     file.exist = true
  //     file.component = import(`@/components/regulator/${regulator}/${componentName}`)
  //   }

  //   return file
  // },
  getWithdrawMethods(reg) {
    return regulator[reg].getWithdrawMethods
  },
  proTraderTools: {
    marketBuzz: {
      mainTitle: 'Market buzz',
      contentTitle: 'Access news coverage and media content covering 35,000+ tradable assets.',
      imagePath: require('@/assets/images/tradingTools/MarketBuzz.png'),
      contentsArray: [
        {
          title: 'Next-gen AI market news',
          contents:
            'Get the latest news coverage, media content, and price events across more than 35,000 tradable assets including 300+ currencies, thousands of stocks, 50 Indices and More!',
        },
        {
          title: 'Popular products',
          contents: 'The buzz meter shows the volume of social media chatter and news about your favourite assets.',
        },
        {
          title: 'Who is saying what',
          contents: 'Check out the ratio of professional media versus social media mentions.',
        },
        {
          title: 'Topic rankings',
          contents: 'View the most discussed market topics at any given moment.',
        },
      ],
    },
    featuredIdea: {
      mainTitle: 'Featured ideas',
      contentTitle: 'View actionable technical trading setups and follow their progress in real time.',
      imagePath: require('@/assets/images/tradingTools/FeaturedIdeas.png'),
      contentsArray: [
        {
          title: 'Tailored trade ideas and setups',
          contents:
            'Access technical and fundamental trade ideas based on proven, back tested strategies across all your favourite currency pairs and technical setups.',
        },
        {
          title: 'Custom Filters',
          contents: 'Filter trade ideas based on your preferred Forex pairs and technical analysis style.',
        },
        {
          title: 'Learn on the go',
          contents: 'Access not only trade setups, but trading education that teaches trading entry and exit methods.',
        },
        {
          title: 'Real-time trades',
          contents: 'View trade setups on live price charts and track each trade as it hits its target.',
        },
      ],
    },
    economicCalendar: {
      mainTitle: 'Economic calendar',
      contentTitle: 'Enjoy around the clock real-time economic data from across the globe.',
      imagePath: require('@/assets/images/tradingTools/EconomicCalendar.png'),
      contentsArray: [
        {
          title: 'Live macro-economic market events',
          contents:
            'Prepare for success with actionable, real-time economic data and act on market moving events from more than 30 countries across the globe.',
        },
        {
          title: 'Timezone detection',
          contents: 'Our calendar knows your timezone, so news times are displayed according to where you are.',
        },
        {
          title: 'Customize your feed',
          contents: 'Choose the news that is important to you and filter news by country and impact.',
        },
        {
          title: 'Realtime data',
          contents: 'All economic data is updated live so you can act on all the latest data as it occurs.',
        },
      ],
    },
    analystView: {
      mainTitle: 'Analyst views',
      contentTitle: 'View engaging and educational technical trading insights across 80,000 instruments.',
      imagePath: require('@/assets/images/tradingTools/AnalystViews.png'),
      contentsArray: [
        {
          title: 'Simple and actionable trading plans',
          contents:
            'Leverage the best of both worlds with a unique combination of quantitative technology and technical analysis expertise covering 80,000 instruments.',
        },
        {
          title: 'Actionable Trade Setups',
          contents: 'With clear trendlines and key levels shown, you can capitalize on live trade setups.',
        },
        {
          title: 'Position Management',
          contents: 'All setups contain clear reversal areas that invalidate a setup so you can manage your risk.',
        },
        {
          title: 'Active Monitoring',
          contents: 'Stay agile by monitoring the existing trade positions, or validating new setups as they unfold.',
        },
      ],
    },
    howtoTrade: {
      mainTitle: 'HowtoTrade Training Room',
      contentTitle: 'Trading education in one place, with courses to suit every level of ambition.',
      contentSubTitle: 'You’re in the right place if this sounds like you...',
      imagePath: require('@/assets/images/tradingTools/HowToTrade.png'),
      contentsArray: [
        {
          imagePath: require('@/assets/images/tradingTools/howToTrade/icon1.png'),
          contents: "You're new to trading & don't know where to start.",
        },
        {
          imagePath: require('@/assets/images/tradingTools/howToTrade/icon2.png'),
          contents: "You're already trading but not happy with your performance.",
        },
        {
          imagePath: require('@/assets/images/tradingTools/howToTrade/icon3.png'),
          contents: 'You would like to improve your knowledge on trading.',
        },
        {
          imagePath: require('@/assets/images/tradingTools/howToTrade/icon4.png'),
          contents: 'You’d like to learn trading skill to reach your life goals.',
        },
      ],
      contentBottomText: 'Join one of the biggest trader communities for free while you are trading VT Markets!',
    },
    acuitySignalCentre: {
      mainTitle: 'menu.AS_CENTRE',
      contentTitle: 'proTraderTools.acuitySignalCentre.contentTitle',
      imagePath: require('@/assets/images/tradingTools/AcuitySignalCentre.png'),
      contentsArray: [
        {
          title: 'proTraderTools.acuitySignalCentre.contents.title1',
          contents: 'proTraderTools.acuitySignalCentre.contents.content1',
        },
        {
          title: 'proTraderTools.acuitySignalCentre.contents.title2',
          contents: 'proTraderTools.acuitySignalCentre.contents.content2',
        },
        {
          title: 'proTraderTools.acuitySignalCentre.contents.title3',
          contents: 'proTraderTools.acuitySignalCentre.contents.content3',
        },
        {
          title: 'proTraderTools.acuitySignalCentre.contents.title4',
          contents: 'proTraderTools.acuitySignalCentre.contents.content4',
        },
      ],
    },
  },
  getCheckMethodMinAmount(reg) {
    return reg ? regulator[reg].withdrawSetup.checkMethodMinAmount : false
  },
  getCancelWithdraw(reg) {
    return reg ? regulator[reg].withdrawSetup.cancelWithdraw : false
  },
}
